import { jsx as _jsx } from "react/jsx-runtime";
import { DecoratorBlockNode } from '@lexical/react/LexicalDecoratorBlockNode';
import { $createFileNode, convertToFileElement } from './FileUtils';
import FileComponent from './FileComponent';
export class FileNode extends DecoratorBlockNode {
    static getType() {
        return 'snfile';
    }
    constructor(id, format, key, zoomLevel) {
        super(format, key);
        this.__id = id;
        this.__zoomLevel = zoomLevel || 100;
    }
    static clone(node) {
        return new FileNode(node.__id, node.__format, node.__key, node.__zoomLevel);
    }
    static importJSON(serializedNode) {
        return $createFileNode(serializedNode.fileUuid).updateFromJSON(serializedNode);
    }
    updateFromJSON(serializedNode) {
        return super.updateFromJSON(serializedNode).setZoomLevel(serializedNode.zoomLevel);
    }
    exportJSON() {
        return {
            ...super.exportJSON(),
            fileUuid: this.getId(),
            zoomLevel: this.__zoomLevel,
        };
    }
    static importDOM() {
        return {
            div: (domNode) => {
                if (!domNode.hasAttribute('data-lexical-file-uuid')) {
                    return null;
                }
                return {
                    conversion: convertToFileElement,
                    priority: 2,
                };
            },
        };
    }
    exportDOM() {
        const element = document.createElement('span');
        element.setAttribute('data-lexical-file-uuid', this.__id);
        const text = document.createTextNode(this.getTextContent());
        element.append(text);
        return { element };
    }
    getId() {
        return this.__id;
    }
    getTextContent(_includeInert, _includeDirectionless) {
        return `[File: ${this.__id}]`;
    }
    setZoomLevel(zoomLevel) {
        const self = this.getWritable();
        self.__zoomLevel = zoomLevel;
        return self;
    }
    decorate(_editor, config) {
        const embedBlockTheme = config.theme.embedBlock || {};
        const className = {
            base: embedBlockTheme.base || '',
            focus: embedBlockTheme.focus || '',
        };
        return (_jsx(FileComponent, { className: className, format: this.__format, setFormat: this.setFormat.bind(this), nodeKey: this.getKey(), fileUuid: this.__id, zoomLevel: this.__zoomLevel, setZoomLevel: this.setZoomLevel.bind(this) }));
    }
}
